/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDepositBankAccount200Response
 */
export interface GetDepositBankAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'bankCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountHolder': string;
    /**
     * 
     * @type {string}
     * @memberof GetDepositBankAccount200Response
     */
    'accountType': GetDepositBankAccount200ResponseAccountTypeEnum;
}

export const GetDepositBankAccount200ResponseAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type GetDepositBankAccount200ResponseAccountTypeEnum = typeof GetDepositBankAccount200ResponseAccountTypeEnum[keyof typeof GetDepositBankAccount200ResponseAccountTypeEnum];


